export const GET_COMPANY_DETAIL = "GET_COMPANY_DETAIL"
export const GET_COMPANY_DETAIL_SUCCESS = "GET_COMPANY_DETAIL_SUCCESS"
export const GET_COMPANY_DETAIL_ERROR = "GET_COMPANY_DETAIL_ERROR"

export const NEW_COMPANY_ADD = "NEW_COMPANY_ADD"
export const NEW_COMPANY_ADD_SUCCESS = "NEW_COMPANY_ADD_SUCCESS"
export const NEW_COMPANY_ADD_ERROR = "NEW_COMPANY_ADD_ERROR"

export const COMPANY_STATUS = "COMPANY_STATUS"
export const COMPANY_STATUS_SUCCESS = "COMPANY_STATUS_SUCCESS"
export const COMPANY_STATUS_ERROR = "COMPANY_STATUS_ERROR"

export const GET_ONE_COMPANY_DETAIL="GET_ONE_COMPANY_DETAIL"
export const GET_ONE_COMPANY_DETAIL_SUCCESS="GET_ONE_COMPANY_DETAIL_SUCCESS"
export const GET_ONE_COMPANY_DETAIL_ERROR="GET_ONE_COMAPNY_DETAIL_ERROR"

export const DOWNLOAD="DOWNLOAD"
export const DOWNLOAD_SUCCESS="DOWNLOAD_SUCCESS"
export const DOWNLOAD_ERROR="DOWNLOAD_ERROR"

// delete
export const DELETE_ORGANIZATION = "DELETE_ORGANIZATION"
export const DELETE_ORGANIZATION_SUCCESS = "DELETE_ORGANIZATION_SUCCESS"
export const DELETE_ORGANIZATION_FAIL = "DELETE_ORGANIZATION_FAIL"


